export default (event) => {
  const { checked, type, value } = event.target;
  return isCheckbox(type) ? checked : value;
}

function isCheckbox(type) {
  return type == 'checkbox';
}
